import React from 'react';
import SearchBar from '../../../ui/elements/SearchBar';
import HeaderIcons from '../../../ui/elements/headerIcons';
import UserProfile from '../../../ui/elements/UserProfile';
import HeaderMobileDashboard from './sub/MobileHeader';
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const DashboardHeader: React.FC = () => {
   const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [scrolled, setScrolled] = useState(false);
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
      e.preventDefault();
      if (searchQuery.trim()) {
        navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
        setIsMenuOpen(false);
        setIsSearchVisible(false);
      }
  };

  return (
    <header className="w-full p-1 md:px-6 py-3">

      {/* MOBILE */}
      <div className="md:hidden">
        <HeaderMobileDashboard
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          isSearchVisible={isSearchVisible}
          setIsSearchVisible={setIsSearchVisible}
          setIsMenuOpen={setIsMenuOpen}
          handleSearch={handleSearch}
          scrolled={scrolled}
        />
      </div>

      {/* DESKTOP */}
      <div className="hidden md:flex items-center justify-between">

        {/* Title */}
        <h1 className="text-[22px] font-semibold text-gray-800">
          Hey, Fabricio! Welcome back 👋
        </h1>

        {/* Center Search */}
        <div className="flex-1 mx-10">
          <SearchBar />
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-6">
          <HeaderIcons />
          <UserProfile />
        </div>

      </div>
    </header>
  );
};

export default DashboardHeader;